import { z } from "zod/v4";

export * from "./html-snapshot";

export const toJsonString = z.preprocess(
  (val) => JSON.stringify(val),
  z.string()
);
export const PluginErrorsSchema = z.object({
  message: toJsonString.optional(),
  stackTrace: z.string().optional(),
});

export const DeviceSchema = z.object({
  os: z
    .object({
      name: z.string(),
      version: z.union([z.string(), z.number()]),
    })
    .optional(),
  browser: z
    .object({
      name: z.string(),
      version: z.union([z.string(), z.number()]),
    })
    .optional(),
  agent: z.string().optional(),
  useragent: z.string().optional(),
});

/*
  We manually parse the body since navigator.sendBeacon()
  doesn't allow custom headers for content-type
 */
export const preprocessRequestBody = (val: unknown): unknown => {
  if (typeof val === "string") {
    let body = val;
    for (let i = 0; i <= 3; i++) {
      try {
        body = JSON.parse(body);
      } catch (e) {
        return body;
      }
    }
  }
  return val;
};

export const PluginExceptionsParsedBodySchema = z.object({
  device: DeviceSchema.default({}),
  currency: z.string().nullish(),
  href: z.string().nullish(),
  buildId: z.number().nullish(),
  storeName: z.string().nullish(),
  orgId: z.string().nullish(),
  errors: PluginErrorsSchema.array(),
});

export const PluginExceptionsRequestBodySchema = z.preprocess(
  preprocessRequestBody,
  PluginExceptionsParsedBodySchema
);

export const PluginExceptionsResponseBodySchema = z.object({
  status: z.union([z.literal("OK"), z.literal("FAIL"), z.literal("THROTTLED")]),
});

export type PluginExceptionsRequestBodyType = z.infer<
  typeof PluginExceptionsParsedBodySchema
>;
export type PluginExceptionsResponseBodyType = z.infer<
  typeof PluginExceptionsResponseBodySchema
>;
export type PluginExceptionsParsedBodySchema = z.infer<
  typeof PluginExceptionsParsedBodySchema
>;
